module.exports = __webpack_public_path__ + "img/gus.7d60b75c.jpg";